import { useEffect, useRef, useState } from "react";
import { ArrowUpRight, WechatLogo, X } from "@phosphor-icons/react";
import QRCode from "qrcode";
import type { AssessmentCategory } from "../shared/contracts";
import { useMedia } from "../lib/useMedia";

export function AuthEntryButton({ className = "primary-button", children = "立即申请考核", assessmentCategory }: { className?: string; children?: string; assessmentCategory?: AssessmentCategory }) {
  const [open, setOpen] = useState(false);
  const [qr, setQr] = useState("");
  const dialogRef = useRef<HTMLDialogElement>(null);
  const mobile = useMedia("(max-width: 720px)");

  const entryPath = assessmentCategory ? `/candidate?assessmentCategory=${assessmentCategory}&wechat=1` : "/candidate?wechat=1";

  useEffect(() => {
    let active = true;
    setQr("");
    QRCode.toDataURL(`${window.location.origin}${entryPath}`, { width: 360, margin: 1, color: { dark: "#07130d", light: "#ffffff" } }).then((value) => { if (active) setQr(value); }).catch(() => { if (active) setQr(""); });
    return () => { active = false; };
  }, [entryPath]);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  const enter = () => {
    if (mobile) window.location.href = entryPath;
    else setOpen(true);
  };

  return (
    <>
      <button className={className} type="button" onClick={enter}>{children}<ArrowUpRight size={20} weight="bold" /></button>
      <dialog className="auth-dialog" ref={dialogRef} onClose={() => setOpen(false)}>
        <button className="dialog-close" type="button" aria-label="关闭" onClick={() => setOpen(false)}><X size={20} /></button>
        <span className="dialog-icon"><WechatLogo size={28} weight="fill" /></span>
        <p className="eyebrow">WECHAT AUTHORIZATION</p>
        <h2>请在微信中继续</h2>
        <p>使用微信扫描二维码，通过野羊电竞服务号授权后填写微信号并申请考核。</p>
        {qr && <img className="auth-dialog__qr" src={qr} alt="微信授权入口二维码" />}
        <small>本地开发环境会进入明确标识的模拟授权页。</small>
      </dialog>
    </>
  );
}
